'use strict';

import { calcProgress } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const rank = document.querySelector('#js-rank-circle');
  const circle = document.querySelector('#js-rank-circle-percent');

  if(circle) {
    let dasharray = calcProgress(circle);
    const viewportHeight = document.documentElement.clientHeight
    const offsetBottom = 200;
    let flag = false;
    const rankLine = document.querySelectorAll('.js-progress');
    let positionRank = rank.getBoundingClientRect().top;

    if (positionRank < (viewportHeight - offsetBottom)) {
      circle.style.strokeDashoffset = dasharray;
      flag = true;

      rankLine.forEach((item) => {
        item.setAttribute('style', `--percent: ${item.getAttribute('data-percent')}%`)
      });
    }

    window.addEventListener('scroll', () => {
      let positionRank = rank.getBoundingClientRect().top;

      if (positionRank < (viewportHeight - offsetBottom)) {
        circle.style.strokeDashoffset = dasharray;
        flag = true;

        rankLine.forEach((item) => {
          item.setAttribute('style', `--percent: ${item.getAttribute('data-percent')}%`)
        });
      }
    });

    window.addEventListener('resize', () => {
      dasharray = calcProgress(circle);
      if (flag) {
        circle.style.strokeDashoffset = dasharray;
      }
    })
  }
});